"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeCategory = exports.LawThemes = exports.TreeContent = void 0;
exports.TreeContent = {
    fromRaw: function (treeData) {
        return JSON.stringify(treeData);
    },
    toRaw: function (treeContent) {
        var jsonString;
        try {
            // Attempt to treat treeContent as a JSON string
            jsonString = treeContent.toString();
            JSON.parse(jsonString);
        }
        catch (error) {
            // If treeContent is not a valid JSON string, serialize it
            jsonString = JSON.stringify(treeContent);
        }
        try {
            return JSON.parse(jsonString);
        }
        catch (parseError) {
            console.error('Failed to parse treeContent', parseError);
            return [];
        }
    },
};
exports.LawThemes = {
    ECONOMIC_LAW: 'economic-law',
    COMMERCIAL_LAW: 'commercial-law',
    PROCEDURAL_LAW: 'procedural-law',
    PRACTICAL_WORKS: 'practical-works',
    OTHER: 'other',
};
// dummyLevel: set to "true" for book trees whose first title level is "part"
// otherwise first level is "book"
var TreeCategory;
(function (TreeCategory) {
    TreeCategory["BUSINESS_EURO"] = "Droit europ\u00E9en des affaires";
    TreeCategory["CODE"] = "L\u00E9gislation";
    TreeCategory["COMPETITION"] = "Concurrence";
    TreeCategory["CONSUMER_AFFAIRS"] = "Consommation";
    TreeCategory["DISTRIBUTION"] = "Distribution";
    TreeCategory["OTHER"] = "Autre";
})(TreeCategory || (exports.TreeCategory = TreeCategory = {}));
//# sourceMappingURL=trees.js.map